import {
  jb_region_indicator_css_default
} from "./chunk.QWOXQTGX.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-region-indicator/jb-region-indicator.ts
var JbRegionIndicator = class extends r {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      label: "Change your current location and language"
    };
  }
  firstUpdated() {
    const itemWrapper = this.shadowRoot.querySelector("div");
    itemWrapper.addEventListener("click", (e) => {
      e.preventDefault();
      this.dispatchEvent(new CustomEvent("region-indicator:clicked", { bubbles: true, composed: true }));
    });
    itemWrapper.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.code === "Space") {
        e.preventDefault();
        e.target.click();
      }
    });
  }
  _renderItem(item) {
    return ke`<span class="indicator-item">
      ${item.hasGlobe ? ke`<jb-globe-icon></jb-globe-icon><span class="short">${item.text}</span><span>${item.textFull}</span>` : ke`<span class="short">${item.text}</span><span>${item.textFull}</span>`}
    </span>`;
  }
  render() {
    return ke`<div
      tabindex="0"
      role="button"
    >
      <span class="sr-only">${this.ariaLabels?.label ?? this.ARIALABELS_DEFAULT.label}</span>
      <div>${this.items?.map((item) => this._renderItem(item))}</div>
    </div>`;
  }
};
JbRegionIndicator.styles = [reset_css_default, jb_region_indicator_css_default];
__decorateClass([
  n({ type: Object })
], JbRegionIndicator.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Array })
], JbRegionIndicator.prototype, "items", 2);
JbRegionIndicator = __decorateClass([
  customElement("jb-region-indicator")
], JbRegionIndicator);

export {
  JbRegionIndicator
};
